export const FETCH_ADMIN_AUDIT_TRAIL =
  'src/containers/admin_page/FETCH_ADMIN_AUDIT_TRAIL';

export const RESET_ADMIN_AUDIT_TRAIL =
  'src/containers/admin_page/RESET_ADMIN_AUDIT_TRAIL';
